import { AlignmentType } from "docx";

export const DAILY_LESSON_LOG_DESCRIPTION = 'Easily create a daily lesson log!';
export const DAILY_LESSON_LOG_PAGE_TITLE = 'Daily Lesson Log Page';

const DARK_GRAY_HEXCODE = '404040'
const BLACK_HEXCODE = '000000'
const createHeaderRows = (texts, data) => {
  const headerData = [
    { key: 'school', isBold: true },
    { key: 'gradeLevel', isBold: true, value: data.grade ?? '' },
    { key: 'teacher', isBold: true },
    { key: 'learningArea', isBold: true, value: data.subject ?? '' },
    { key: 'teachingDates', isBold: true },
    { key: 'quarter', isBold: true },
  ];
  return headerData.flatMap(({ key, isBold, value = '' }) => [
    { text: texts[key], isBold, color: DARK_GRAY_HEXCODE, alignmentType: AlignmentType.RIGHT },
    { text: value, isBold: false, color: BLACK_HEXCODE, alignmentType: AlignmentType.LEFT },
  ]);
};

const englishTexts = {
  school: 'School',
  gradeLevel: 'Grade Level',
  teacher: 'Teacher',
  learningArea: 'Learning Area',
  teachingDates: 'Teaching Dates and Time',
  quarter: 'Quarter',
};

const filipinoTexts = {
  school: 'Paaralan',
  gradeLevel: 'Antas ng Baitang',
  teacher: 'Guro',
  learningArea: 'Larangan ng Pagkatuto',
  teachingDates: 'Mga Petsa at Oras ng Pagtuturo',
  quarter: 'Kwarter',
};

export const englishHeaderRows = (data) => createHeaderRows(englishTexts, data);
export const filipinoHeaderRows = (data) => createHeaderRows(filipinoTexts, data);